import { Component, Inject, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { translate } from '@jsverse/transloco';
import { WarningPopupButtons } from '@inmoment/the-kitchen';

import { SimpleDialogOptions } from 'app/components/simple-dialog.component';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-xi-warning-popup',
  templateUrl: './lex-xi-warning-popup.component.html',
  styleUrls: ['./lex-xi-warning-popup.component.css'],
  standalone: false,
})
export class LexXiWarningPopupComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  public popupButtons: WarningPopupButtons;
  public title: string;
  public content: string;

  constructor(
    private dialogRef: MatDialogRef<LexXiWarningPopupComponent>,
    @Inject(MAT_DIALOG_DATA) private options: SimpleDialogOptions
  ) {}

  ngOnInit() {
    this.popupButtons = {
      proceed: {
        text: '',
      },
      cancel: {
        text: '',
      },
    };
    const confirmTitle = this.options.confirmTitle;
    const cancelTitle = this.options.cancelTitle;
    this.popupButtons.proceed.text = confirmTitle ?? translate('lex-xi-warning-popup.confirm');
    this.popupButtons.cancel.text = cancelTitle ?? translate('lex-xi-warning-popup.cancel');
    this.title = this.options.title;
    this.content = this.options.content;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
